import { useState } from "react";
import Modal from "../../modal";
import styles from "./styles.module.css";
import { db } from "../../firebase";
export default function NewApp({ onSubmit }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");

  const handleSave = async () => {
    const regexExp = new RegExp("^[a-z-]+$");
    if (!regexExp.test(name)) {
      alert("Please Format the App Name Correclty");
      return;
    }
    const doc = await db.collection("apps").doc(name).get();
    if (doc.exists) {
      alert("Sorry, an app with that name already exists");
      return;
    }
    onSubmit(name);
  };
  return (
    <>
      <button onClick={() => setOpen(true)} className={styles.newAppButton}>
        New App
      </button>
      <Modal open={open} onClose={() => setOpen(false)}>
        <div className={styles.newApp}>
          <div className={styles.cardTitle}>New App</div>
          <div className={styles.inputText}>App Name</div>
          <input
            value={name}
            className={"input"}
            onChange={(e) => setName(e.target.value)}
          />
          <div className={styles.helpText}>
            App names must be lowercase and only contain letters and -
          </div>
          <button onClick={handleSave} className={styles.newAppButton}>
            Create
          </button>
        </div>
      </Modal>
    </>
  );
}
